// components/HeroSection.js
import { Container, Row, Col, Button } from 'react-bootstrap';
import heroBackground from '../assets/images/hero-background.jpg';

const HeroSection = () => {
  const heroStyle = {
    backgroundImage: `linear-gradient(
        rgba(0,0,0,.55),
        rgba(0,0,0,.55)
      ), url(${heroBackground})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    // backgroundAttachment: 'fixed', // optional: remove on mobile for performance
    color: 'white',
    paddingTop: '150px',
    paddingBottom: '100px',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    textShadow: '0 2px 8px rgba(0,0,0,.6)' // boosts readability
  };

  return (
    <section id="home" style={heroStyle}>
      <Container>
        <Row className="justify-content-center text-center">
          <Col lg={9}>
            <h1 className="display-3 fw-bold mb-4">
              Decoding Biology through Computational Innovation
            </h1>
            <p className="lead mb-4 fs-5">
              We are the <strong>Translational Bioinformatics Research Lab</strong> at the Marshall University.
              We develop and apply advanced computational frameworks, AI models, and integrative
              platforms to solve complex challenges in biomedicine and multi-omics.
            </p>
            <div>
              <Button variant="warning" size="lg" href="/research" className="me-3 fw-semibold">
                Explore Our Research
              </Button>
              <Button variant="light" size="lg" href="#featured-tools" className="fw-semibold">
                Our Tools & Software
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;
